import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "custom-toast-body text-bg-secondary" }
const _hoisted_3 = { class: "me-auto" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-secondary",
  "data-bs-dismiss": "toast"
}, " Undo ", -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close me-1",
  "data-bs-dismiss": "toast",
  "aria-label": "Close"
}, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: `undo-delete-toast-${_ctx.$.uid}`,
    class: "toast fade m-auto mb-1 mb-md-3 ms-md-auto me-md-3",
    role: "status",
    "aria-live": "polite",
    "aria-atomic": "true",
    "data-bs-delay": "15000"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("strong", _hoisted_3, _toDisplayString(_ctx.message), 1 /* TEXT */),
      _createElementVNode("form", {
        onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.undoClicked && _ctx.undoClicked(...args)), ["prevent"]))
      }, _hoisted_5, 32 /* HYDRATE_EVENTS */),
      _hoisted_6
    ])
  ], 8 /* PROPS */, _hoisted_1))
}